import { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const textClass = scrolled ? 'text-foreground-950' : 'text-background-50';
  const textMutedClass = scrolled ? 'text-foreground-600' : 'text-background-50/80';
  const textHoverClass = scrolled ? 'hover:text-foreground-950' : 'hover:text-background-50';
  const logoClass = scrolled ? 'text-foreground-950' : 'text-background-50';
  const iconClass = scrolled ? 'text-foreground-950' : 'text-background-50';

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-20 px-6 md:px-12">
        <Link
          to="/"
          className={`font-bold text-lg tracking-tight whitespace-nowrap cursor-pointer transition-colors duration-300 ${logoClass}`}
        >
          hoobuy.homes
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `text-sm font-semibold transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                isActive
                  ? (scrolled ? 'text-foreground-950' : 'text-background-50')
                  : `${scrolled ? 'text-foreground-600' : 'text-background-50/80'} hover:${scrolled ? 'text-foreground-950' : 'text-background-50'}`
              }`
            }
          >
            Início
          </NavLink>
          <a
            href="#categorias"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${textMutedClass} ${textHoverClass}`}
          >
            Categorias
          </a>
          <Link
            to="/artigo/guia-de-compras-hoobuy"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${textMutedClass} ${textHoverClass}`}
          >
            Guia de Compras
          </Link>
          <a
            href="#comparacao"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${textMutedClass} ${textHoverClass}`}
          >
            Comparação
          </a>
          <a
            href="#faq"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${textMutedClass} ${textHoverClass}`}
          >
            FAQ
          </a>

          <div className="flex items-center gap-3 ml-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              hoobuy sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className={`inline-flex items-center px-5 py-2.5 text-sm font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'border border-foreground-300 text-foreground-950 hover:bg-foreground-50'
                  : 'border border-background-50/30 text-background-50 hover:bg-background-50/10'
              }`}
            >
              buy it now
            </a>
          </div>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Menu"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl transition-colors duration-300 ${iconClass}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-6 py-5 flex flex-col gap-3">
          <NavLink
            to="/"
            onClick={() => setMobileOpen(false)}
            className="text-sm font-semibold text-foreground-950 cursor-pointer py-1"
          >
            Início
          </NavLink>
          <Link
            to="/artigo/guia-de-compras-hoobuy"
            onClick={() => setMobileOpen(false)}
            className="text-sm font-medium text-foreground-600 cursor-pointer py-1"
          >
            Guia de Compras
          </Link>
          <a href="#categorias" onClick={() => setMobileOpen(false)} className="text-sm font-medium text-foreground-600 cursor-pointer py-1">Categorias</a>
          <a href="#comparacao" onClick={() => setMobileOpen(false)} className="text-sm font-medium text-foreground-600 cursor-pointer py-1">Comparação</a>
          <a href="#faq" onClick={() => setMobileOpen(false)} className="text-sm font-medium text-foreground-600 cursor-pointer py-1">FAQ</a>
          <a href="#artigos" onClick={() => setMobileOpen(false)} className="text-sm font-medium text-foreground-600 cursor-pointer py-1">Artigos SEO</a>

          <div className="flex flex-col gap-5 pt-3 border-t border-background-200 mt-2">
            <div className="grid grid-cols-2 gap-3">
              {[
                { n: 'Sapatos', u: 'https://kaspreadsheet.com/category-911-Shoes.html', i: 'ri-footprint-line' },
                { n: 'Moletons', u: 'https://kaspreadsheet.com/search-912/name/Shoes.html', i: 'ri-t-shirt-line' },
                { n: 'Camisetas', u: 'https://kaspreadsheet.com/search-913/name/Shoes.html', i: 'ri-t-shirt-line' },
                { n: 'Jaquetas', u: 'https://kaspreadsheet.com/search-914/name/Shoes.html', i: 'ri-t-shirt-line' },
                { n: 'Calças', u: 'https://kaspreadsheet.com/search-915/name/Shoes.html', i: 'ri-t-shirt-line' },
                { n: 'Bonés', u: 'https://kaspreadsheet.com/search-916/name/Shoes.html', i: 'ri-user-star-line' },
                { n: 'Conjuntos', u: 'https://kaspreadsheet.com/search-917/name/Shoes.html', i: 'ri-stack-line' },
                { n: 'Íntima', u: 'https://kaspreadsheet.com/search-918/name/Shoes.html', i: 'ri-shirt-line' },
                { n: 'Jersey', u: 'https://kaspreadsheet.com/search-919/name/Shoes.html', i: 'ri-team-line' },
                { n: 'Acessórios', u: 'https://kaspreadsheet.com/search-920/name/Shoes.html', i: 'ri-bear-smile-line' },
                { n: 'Bolsas', u: 'https://kaspreadsheet.com/search-921/name/Shoes.html', i: 'ri-handbag-line' },
                { n: 'Cintos', u: 'https://kaspreadsheet.com/search-922/name/Shoes.html', i: 'ri-link' },
                { n: 'Perfumes', u: 'https://kaspreadsheet.com/search-923/name/Shoes.html', i: 'ri-contrast-drop-line' },
                { n: 'Outros', u: 'https://kaspreadsheet.com/search-924/name/Shoes.html', i: 'ri-more-line' },
              ].map((c) => (
                <a
                  key={c.n}
                  href={c.u}
                  target="_blank"
                  rel="noopener nofollow"
                  onClick={() => setMobileOpen(false)}
                  className="flex items-center gap-2 px-3 py-2 bg-background-100 rounded-xl text-xs font-medium text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer"
                >
                  <i className={`${c.i} text-foreground-500`}></i>
                  {c.n}
                </a>
              ))}
            </div>
            <div className="flex flex-col gap-2">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full whitespace-nowrap cursor-pointer"
              >
                hoobuy sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-5 py-2.5 border border-foreground-300 text-foreground-950 text-sm font-semibold rounded-full whitespace-nowrap cursor-pointer"
              >
                buy it now
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}